export enum TeamMemberStatus {
   Active,
   Inactive
}
